var site = site || {};

(function ($) {
  Drupal.behaviors.expandableContentGridFormatterV1 = {
    attach: function (context, settings) {
      $('.js-expandable-content-grid-formatter-v1', context).each(function () {
        var $me = $(this),
          columns = 3; // Minimum number of columns

        if (($count = $me.data('column-count')) > 0) {
          columns = $count;
        }
        var $items = $me.find('li.grid-container-li'),
          $iLen = $items.length;

        for (var i = 0; i < $iLen; i += columns) {
          $items.slice(i, i + columns).wrapAll('<div class="row js-grid-row clearfix"></div>');
        }

        $('.js-grid-row', context).not('.js-expandable-added').append("<div class='js-expanded-content expanded-content clearfix'></div>").addClass('js-expandable-added');

        // Disable anchor link inside expandable content
        $('.js-expandable', context).find('a').on('click', function (e) {
          e.preventDefault();
        });

        // Show Expanded Content
        $('.js-expandable', context).on('click', function () {
          var $this = $(this);
          var $expandableContent = $this.find('.js-expandable-content').html();

          $this.parents('.js-expandable-content-grid-formatter-v1').find('.js-grid-expanded .js-expanded-details').html($expandableContent);
          var $gridContent = $this.parents('.js-expandable-content-grid-formatter-v1').find('.js-grid-expanded').html();
          var $gridExpanded = $this.parents('.js-grid-row').find('.js-expanded-content').html($gridContent);

          $('.js-expanded-content', context).removeClass('expandedOpen').hide();
          $('.js-grid-row', context).find('.grid-container-li').removeClass('contentActive');
          $('.js-expandable .caret').addClass('hidden');
          $this.find('.caret').removeClass('hidden');

          // Show expanded content in slideDown for PC
          if ($(window).width() >= 768) {
            $this.parents('.js-grid-row').find('.js-expanded-content').addClass('expandedOpen').slideDown(1000);
            $this.parents('.grid-container-li').addClass('contentActive');
            // CX-8780 Flex Slider Call after slideDown
            var $promoContainer = $this.parents('.js-grid-row').find('.js-expanded-content').find('.full-width-promo-v1');

            if ($promoContainer.length > 0) {
              $promoContainer.removeClass('full-width-promo-v1-flexslider-processed');
              site.fullWidthPromoV1.init();
            }
            $('html, body').animate({ scrollTop: $('.js-expanded-content:visible').offset().top - 50 }, 1000);
          } else { // Show expanded content in overlay for Mobile
            generic.overlay.launch({
              content: $gridExpanded.clone(true),
              includeBackground: true,
              hideOnClickOutside: true,
              includeCloseLink: false,
              cssClass: 'expanded-content-overlay js-expanded-content-overlay',
              cssStyle: {
                padding: '25px',
                height: $(window).height()
              }
            });
            $('.js-expanded-content-overlay', context).find('.js-expanded-content').show();
          }
        });

        // Hide Expanded content
        $('.js-expanded-content', context).on('click', '.js-expanded-close', function (e) {
          if ($(window).width() >= 768) {
            $(this).parents('.js-expanded-content').removeClass('expandedOpen').slideUp(1000);
            $('.js-grid-row', context).find('.grid-container-li').removeClass('contentActive');
          } else {
            e.preventDefault();
            generic.overlay.hide();
          }
          $('.js-expandable .caret').addClass('hidden');
        });

        // Set the height of the columns within each row
        $me.find('.row').each(function () {
          var $cols = $(this).find('li.grid-container-li'),
            ch = 0;

          $(window).resize(function () {
            $cols.each(function () {
              var $el = $(this);

              $el.css({ height: 'auto' });
              var h = $el.outerHeight(true);

              if (h > ch) {
                ch = h;
                $(window).resize();

                return;
              }
            }).height(ch);
          }).resize();
        });
      });
    }
  };
})(jQuery);
